var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJcbcard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 72,
    viewBox: "0 0 99 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.7955 37.4573C76.3964 37.5139 79.0119 37.3423 81.6024 37.5464C84.2257 38.0366 84.858 42.0138 82.5273 43.3163C80.9371 44.1744 79.048 43.6359 77.324 43.7873H73.7955V37.4573ZM83.1062 30.2926C83.684 32.3351 81.7179 34.169 79.7535 33.8877H73.7955C73.8373 31.9616 73.7138 29.8709 73.856 28.0461C76.2428 28.1134 78.6516 27.9088 81.0246 28.1531C82.0442 28.4096 82.8975 29.249 83.1062 30.2926ZM97.4449 0.00221741C97.5558 3.90297 97.4609 8.00988 97.4928 11.9898C97.4854 28.1705 97.5084 44.3507 97.4801 60.5323C97.3755 66.5964 92.009 71.8657 85.9956 71.9867C79.9763 72.0113 73.9562 71.9905 67.936 71.9972V47.5354C74.4952 47.5015 81.0577 47.6042 87.6143 47.4841C90.6558 47.2929 93.9874 45.2831 94.1289 41.9311C94.487 38.5646 91.3177 36.2361 88.3087 35.8683C87.152 35.8382 87.1858 35.5307 88.3087 35.3965C91.1786 34.7753 93.4323 31.8006 92.5879 28.8215C91.8684 25.6882 88.4102 24.4754 85.5337 24.4815C79.6687 24.4416 73.8026 24.4759 67.9374 24.4643C67.9752 19.8976 67.8584 15.3259 68.0004 10.7625C68.4651 4.80789 73.9666 -0.102763 79.8955 0.00377676C85.7461 0.00288522 91.5957 0.00288583 97.4449 0.00266294V0.00221741Z",
    fill: "url(#paint0_linear_1567_28354)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.65601 11.3789C1.80579 5.32441 7.1952 0.0983723 13.2009 0.00988607C19.1979 -0.00861356 25.1958 0.00721243 31.1928 0.00186314C31.1764 20.259 31.2253 40.5183 31.1681 60.7743C30.9371 66.7552 25.6064 71.8816 19.6662 71.9875C13.6578 72.0093 7.64879 71.9906 1.6402 71.9966V46.7101C7.47652 48.0909 13.5968 48.6786 19.5509 47.7628C23.1099 47.1893 27.0039 45.439 28.2089 41.7413C29.0956 38.5783 28.5964 35.2495 28.7284 32.0031V24.4639H18.4243C18.378 29.4502 18.5191 34.4451 18.3497 39.4253C18.072 42.4864 15.0448 44.4313 12.162 44.3274C8.58668 44.3653 1.50177 41.7326 1.50177 41.7326C1.48396 32.3905 1.60548 20.6909 1.65601 11.3798V11.3789Z",
    fill: "url(#paint1_linear_1567_28354)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0347 27.5054C34.4923 27.6206 34.9256 25.6552 34.787 24.9097C34.8239 20.1956 34.7098 15.4764 34.85 10.7657C35.3133 4.78585 40.8572 -0.13706 46.8101 0.00291304H64.341C64.3245 20.26 64.3732 40.5193 64.3163 60.7753C64.085 66.7563 58.754 71.8825 52.8135 71.9886C46.805 72.0113 40.7957 71.9921 34.7868 71.9979V44.293C38.8906 47.6651 44.4683 48.19 49.581 48.1991C53.4354 48.1978 57.2672 47.6027 61.0103 46.7125V41.6369C56.7921 43.7423 51.8333 45.0796 47.1573 43.87C43.8954 43.0569 41.5275 39.8999 41.5803 36.5288C41.2024 33.023 43.2544 29.3217 46.6946 28.2795C50.9658 26.9404 55.6209 27.9646 59.6246 29.7055C60.4824 30.1553 61.353 30.7132 61.0101 29.2774V25.2879C54.314 23.6925 47.188 23.1054 40.4608 24.841C38.5136 25.3911 36.6165 26.2254 35.0347 27.5058V27.5054Z",
    fill: "url(#paint2_linear_1567_28354)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1567_28354",
    x1: 67.7343,
    y1: 34.4604,
    x2: 97.3064,
    y2: 34.4604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58B03A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55B330"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1567_28354",
    x1: 1.01143,
    y1: 36.6887,
    x2: 30.7083,
    y2: 36.6887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F6EB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006DBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1567_28354",
    x1: 34.7434,
    y1: 35.1585,
    x2: 64.3354,
    y2: 35.1585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE0D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E30138"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcbcard);
export default __webpack_public_path__ + "static/media/jcbcard.780ced3249fce5477dc237a6fe4de66b.svg";
export { ForwardRef as ReactComponent };